import {
  CLEAR_ACCESS_CODE_CHALLENGE,
} from 'actiontypes/accessCodes';

export default function clearAccessCodeChallenge() {
  return { type: CLEAR_ACCESS_CODE_CHALLENGE };
}